import bus from '@/utils/bus';
import { getOptionRulesWithNote } from '@/utils/helper';

import MenuItemOptionEditor from '../MenuItemOptionEditor/MenuItemOptionEditor.vue';
import MenuItemOptionItemsViewer from '../MenuItemOptionItemsViewer/MenuItemOptionItemsViewer.vue';

export default {
  name: 'MenuItemOptionWrapper',
  components: {
    MenuItemOptionEditor,
    MenuItemOptionItemsViewer,
  },
  props: {
    option: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      min: this.option?.rules?.min || 0,
      max: this.option?.rules?.max || 0,
      note: this.option?.storeNote || '',
      show: false,
    };
  },
  watch: {
    max(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setRules();
      }
    },
    min(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setRules();
      }
    },
    note(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.option.setStoreNote(this.note);
      }
    },
  },
  beforeDestroy() {
    Object.assign(this.$data, this.$options.data.apply(this));
  },
  methods: {
    getOptionRulesWithNote,
    modifyOptionWithItems(datum = {}) {
      const {
        max = 0,
        min = 0,
        name = '',
        newItems = [],
        note = '',
        removeItemsIndexes = [],
      } = datum;

      this.option
        .setName(name)
        .setStoreNote(note)
        .setRules({
          max,
          min,
        });

      if (removeItemsIndexes?.length) {
        removeItemsIndexes.forEach((itemIndex) => {
          const item = this.option?.items?.find(({ index }) => index === itemIndex);
          if (item) {
            this.removeItem(item);
          }
        });
      }

      if (newItems?.length) {
        bus.$emit('CREATE_OPTION_ITEMS_AND_ASSIGN_TO_OPTION', {
          items: newItems,
          option: this.option,
        });
      }
    },
    removeItem(item) {
      this.option.removeItem(item);
      bus.$emit('REMOVE_MENU_OPTION_ITEM', item);
    },
    removeOption(option) {
      this.$emit('remove-option', option);
    },
    setRules() {
      this.option.setRules({
        max: this.max,
        min: this.min,
      });
    },
    toggleShow(show = false) {
      this.show = show;
    },
  },
};
